import React, { useCallback } from 'react';
import classnames from 'classnames';

import { PlainButton } from 'components';
import Icon from 'assets/icons';

import styles from './VerticalListToggle.module.scss';

export interface VerticalListToggleProps {
  /** @boolean */
  showAllIntegrations: boolean;
  /** @function */
  setShowAllIntegrations: (value: boolean) => void;
}

export const VerticalListToggle: React.FC<VerticalListToggleProps> = ({
  showAllIntegrations,
  setShowAllIntegrations,
}) => {
  const handleButtonClick = useCallback(() => {
    setShowAllIntegrations(!showAllIntegrations);
  }, [showAllIntegrations, setShowAllIntegrations]);

  return (
    <PlainButton
      className={classnames(styles.navItem, showAllIntegrations && styles.open)}
      onClick={handleButtonClick}
    >
      <div className={styles.navTitle}>
        <div className={classnames(styles.icon, styles.moreBlock)}>
          <Icon.TriangleDown className={styles.moreIcon} />
        </div>
        {showAllIntegrations ? 'See Less...' : 'See More...'}
      </div>
    </PlainButton>
  );
};
